<template>
    <div class="flex" :class="{error: error}, $attrs.class">
        <input :id="id"
               ref="input"
               v-bind="{ ...$attrs, class: null }"
               class="mr-2"
               type="checkbox"
               :checked="modelValue"
               v-model="proxyChecked"
               :value="modelValue"/>
        <label v-if="label" class="form-label pt-2" :for="id">{{ label }}</label>
        <div v-if="error" class="form-error">{{ error }}</div>
    </div>
</template>

<script>
import {v4 as uuid} from 'uuid'

export default {
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default() {
                return `text-input-${uuid()}`
            },
        },
        error: String,
        label: String,
        modelValue: {
            type: Boolean,
            default: false
        },
    },
    emits: ['update:modelValue'],

    computed: {
        proxyChecked: {
            get() {
                return this.checked;
            },
            set(val) {
                this.$emit("update:modelValue", val);
            },
        },
    }
}
</script>
